import React, { useEffect, useRef } from "react";
import { useAmountInput } from "./hooks";
import { ReactComponent as EditIcon } from './assets/edit.svg'

import './index.scss'

type AmountInputArgs = {
    onChange: (newAmount: number) => void
    value: number
}

const AmountInput: React.FC<AmountInputArgs> = ({onChange, value}) => {
    const {isActive, activate, handleKeyPress, handleChange, handleBlur, inputValue, displayValue} = useAmountInput(value, onChange)
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        isActive && inputRef.current?.focus()
    }, [isActive])

    if (isActive) {
        return (
            <div className="amount-input"><input ref={inputRef} onKeyUp={handleKeyPress} onBlur={handleBlur} type="number" value={inputValue} onChange={handleChange}/></div>
        )
    } else {
        return (
            <div onClick={activate} className="amount-div centered semi-bold"><EditIcon />{displayValue}</div>
        )
    }
    
} 

export default AmountInput
